// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"f096f279","243":"98dd6539","426":"0141793e","511":"f5608c30","758":"52a5a930","915":"50f054cb"}[chunkId] + ".chunk.js";
};